import { RackOptions } from "../../../../RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "../../../../utils/product-lookup"
import { handleSplitColorUprights, getCustomMaterials } from "../../../../utils/material-utils"
import { getFxtSafetySelection } from "../../../../utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"
import { getSimpleForBuyRequest } from "@/js/helpers/buy-request"

// Shared Config Parts of all FXT's
export function getSharedConfig(rogue: IRogue, buyRequest: BuyRequest): Pick<RackOptions, 'line' | 'safeties' | 'stainlessUprights' | 'numbered' | 'hardware' | 'color' | 'height' | 'materials' | 'accessories' | 'isFunctionalTrainer' | 'rackRoller' | 'weightStackAmount'>{
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)
  const trainer = findBundleProduct(rogue, buyRequest, 'trainer')
  const mainSku = rogue.getProductById(buyRequest.productId).sku
  
  const line = mainSku.startsWith('FML') || mainSku.includes('RML') ? 'RML' : 'RM'
  const numbered = rack?.attributes.edition === 'Numbered' || rack?.attributes.upright_type === 'Numbered' || line === 'RM'
  const height = line === 'RML' ? '90' : (rack?.attributes.rack_height as string)?.replace('"', '') as RackOptions['height']

  // Determine base color and whether front uprights should be stainless
  const { color, stainlessUprights } = handleSplitColorUprights(rack?.attributes.rig_color as string)

  const materials = getCustomMaterials(rogue, buyRequest) || {}
  if (stainlessUprights && !materials.nameplate) {
    materials.nameplate = { branding: { material: 'stainless' } }
  }

  const weightStackAmount = String(trainer?.attributes?.edition)?.includes('300') ? '300' : '250'

  return {
    line,
    numbered,
    color,
    height,
    hardware            : 'isonite',
    safeties            : getFxtSafetySelection(rogue, buyRequest),
    materials,
    stainlessUprights,
    isFunctionalTrainer : true,
    rackRoller          : getAccessoryQuantity(rogue, buyRequest, 'rack roller'),
    accessories         : [],
    weightStackAmount,
  }
}